import React from "react";
import Icon from "../atoms/Icon";

export default ({ text }) => {

    if (!text) return null;

    return <div className="m-sign">
        <Icon className="m-sign__icon" iconName="icon-sign"/>
        <span className="m-sign__text">{ text }</span>
    </div>;
}
